<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable width="500px" persistent>
      <v-card class="DialogTaxList">
        <v-card-title
          :style="'background:' + _cardTitle"
          class="pa-2 pl-4 pr-4"
        >
          {{ $t("mail_relay.detail.note") }}
          <v-spacer></v-spacer>
          <v-btn
            color="#f05c5a"
            dark
            fab
            x-small
            class="elevation-0"
            @click="$emit('close'), $emit('clear')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p v-for="(list_item, index) in $t('typeCode.all')" :key="index">
            <v-layout
              row
              wrap
              justify-center
              align-center
              v-if="list_item.value != ''"
            >
              <v-flex xs11 sm12 md6 lg6>
                <v-chip small :color="list_item.color" dark class="textCenter">
                  {{ list_item.text }}
                </v-chip>
              </v-flex>
              <v-flex xs11 sm12 md6 lg6>
                <span class="black--text"> {{ list_item.text }}</span>
              </v-flex></v-layout
            >
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  props: ["show"],
  data: function () {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters([
      "getter_dataBusiness_profile",
      "getter_dataAccount_profile",
      "getter_apikey",
    ]),
    ...mapState(["backgroudcolor", "pageDetailcolor", "cardTitle"]),
    // New Add
    _cardTitle: {
      get() {
        return this.cardTitle;
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _SellerBranchId: {
      get() {
        return this.getter_dataBusiness_profile["branch_no"];
      },
    },
    _CurrentUser: {
      get() {
        return this.$store.state.usercode;
      },
    },
    // Old
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    _profile: {
      get() {
        return this.$store.getters.profile;
      },
    },
  },
};
</script>
<style scoped>
.DialogTaxList {
  margin: 0px;
  overflow-x: hidden;
}
.textCenter {
  width: 195px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
